$(window).scroll(function() {
  if ($(this).scrollTop() > 250) {
    $('#myHeader').addClass('sticky');
  } else {
    $('#myHeader').removeClass('sticky');
  }
});



// jQuery(document).ready(function($) {
//         var $win = $(window);
//         $('.background').each(function() {
//             var scroll_speed = 5;
//             var $this = $(this);
//             $(window).scroll(function() {
//                 var bgScroll = -(($win.scrollTop() - $this.offset().top) / scroll_speed);
//                 var bgPosition = 'center ' + bgScroll + 'px';
//                 $this.css('background-position', bgPosition);
//             });
//         });
  
//   $(document).ready(function(){
//     $('[data-toggle="tooltip"]').tooltip();
//   });
//     });

// $(window).scroll(function() {
//         if ($(this).scrollTop()) {
//             $('#myHeader').addClass('sticky');
//         } else {
//             $('#myHeader').removeClass('sticky');
//         }
//     });
 jQuery(document).ready(function($){
//             var $win = $(window);
//             $('.background').each(function(){
//                 var scroll_speed = 5;
//                 var $this = $(this);
//                 $(window).scroll(function() {
//                     var bgScroll = -(($win.scrollTop() - $this.offset().top)/ scroll_speed);
//                     var bgPosition = 'center '+ bgScroll + 'px';
//                     $this.css('background-position', bgPosition);
//                 });
//             });
   
//            $(document).on('click', 'a[href^="#"]', function (event) {
//               event.preventDefault();

//               $('html, body').animate({
//                   scrollTop: $($.attr(this, 'href')).offset().top-100
//               }, 500);
//           });
   
           jQuery('#closePop').click(function(){
			jQuery('.bold_options.bold_options_loaded').hide();
           });
   		   jQuery('#openPop').click(function(){
			jQuery('.bold_options.bold_options_loaded').show();
           });
   	
        });


// $(window).scroll(function(){

//         if ($(window).scrollTop() ) {
//             $('header').addClass('sticky');
            

//         }
//         else {
//             $('header').removeClass('sticky');

//         }
//     });

// jQuery(document).ready(function($){
//    $('.owl-carousel').owlCarousel();
//  });
// jQuery(document).ready(function($) {
//   $(".faq-wr > a").on("click", function() {
//     if ($(this).hasClass("active")) {
//       $(this).removeClass("active");
//       $(this)
//         .siblings(".content")
//         .slideUp(200);
//       $(".faq-wr > a i")
//         .removeClass("fa-minus")
//         .addClass("fa-plus");
//     } else {
//       $(".faq-wr > a i")
//         .removeClass("fa-minus")
//         .addClass("fa-plus");
//       $(this)
//         .find("i")
//         .removeClass("fa-plus")
//         .addClass("fa-minus");
//       $(".faq-wr > a").removeClass("active");
//       $(this).addClass("active");
//       $(".content").slideUp(200);
//       $(this)
//         .siblings(".content")
//         .slideDown(200);
//     }
//   });
// });

